import React, { createContext, useState } from 'react'; 
import { GetRankData , GetClubRankData , GetLevelRankData , GetRewardsData} from '../../services/backendServices'; 

// Create a context to store rank data globally
export const RankContext = createContext();

export const RankProvider = ({ children }) => {
    
    // State to hold rank data
    const [rankData, setRankData] = useState([]); 
    const [clubRankData , setClubRankData] = useState([]);
    const [levelRankData ,setLevelRankData] = useState([]);
    const [rewardData , setRewardData] = useState([]);
    // Function to fetch rank data from backend
    const fetchTeamRankData = async () => {
        try {
            const res = await GetRankData();
            if (res) {
                setRankData(res.data); // Set rank data to state
            }
        } catch (e) {
            console.error("Error fetching rank data:", e); // Handle errors
        }
    };

  // Function to fetch Club rank data 
  const fetchClubRankData = async () => {
    try {
        const res = await GetClubRankData();
        if (res) {
            setClubRankData(res.data); // Set rank data to state
        }
    } catch (e) {
        console.error("Error fetching rank data:", e); // Handle errors
    }
}
  // Function to fetch Level rank data 
  const fetchLevelRankData = async () => {
    try {
        const res = await GetLevelRankData();
        if (res) {
            setLevelRankData(res.data); // Set level data to state
        }
    } catch (e) {
        console.error("Error fetching rank data:", e); // Handle errors
    }
}
  // Function to fetch Reward data 
  const fetchRewardData = async () => {
    try {
        const res = await GetRewardsData();
        if (res) {
            setRewardData(res.data); // Set level data to state
        }
    } catch (e) {
        console.error("Error fetching reward data:", e); // Handle errors
    }
}

    // Provide rank data and fetch function to child components
    return (
        <RankContext.Provider value={{ rankData, fetchTeamRankData , fetchClubRankData ,fetchLevelRankData, fetchRewardData ,levelRankData, clubRankData , rewardData}}>
            {children}
        </RankContext.Provider>
    );
};
